import React, { useEffect, useState } from 'react'
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import {SET_ACTIVE_FORM} from '../reducer.js';
// material ui
import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import Theme from '../../debrief/components/Theme';

const useStyles = makeStyles({
  widgetBar: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '50px',
    background: 'rgba(38,38,38,.8)',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '.75rem',
    boxSizing: 'border-box',
  },
  widgetName: {
    color: '#ffffff',
    lineHeight: '26px',
    fontFamily: Theme.typography.fontFamily,
  },
  icon: {
    color: '#ffffff',
    fontSize: '26px',
    opacity: '.8',
    '&:hover': {
      cursor: 'pointer',
      opacity: '1',
    }
  }
});

export default function WidgetBar(props) {
  const classes = useStyles();
  const dispatch = useDispatch()
  
  const componentName = props.context.name;

  const handleClick = (e) => {
    dispatch({ type: SET_ACTIVE_FORM, payload: {
      activeForm: props.context['component'],
      activeFormContext: props.context,
    }})
  }

  return (
    <div className={classes.widgetBar} >
      <div className={classes.widgetName}>{componentName}</div>
      <EditIcon className={classes.icon} onClick={handleClick} />
    </div>
  )
}
